module.exports = __webpack_public_path__ + "img/guide.d89240f6.svg";